import { enqueueSnackbar } from "notistack";
import { bindActionCreators } from "redux";
import { call, cancel, cancelled, fork, put, take } from "redux-saga/effects";

import * as apiCaller from "./../api/apiCaller";
import { globalHistory } from "./../history";
import * as cookies from "./../ultis/cookies";

/**
 * Consts
 */
export const COOKIE_TOKEN = "access_token";

export const INIT_READY = "INIT_READY";

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_CANCEL = "LOGIN_CANCEL";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const REGISTER_WEBRTC = "REGISTER_WEBRTC";
export const REGISTER_WEBRTC_SUCCESS = "REGISTER_WEBRTC_SUCCESS";
export const REGISTER_WEBRTC_ERROR = "REGISTER_WEBRTC_ERROR";

export const CHECK_STATUS = "CHECK_STATUS";

/**
 * Reducer
 */
const initialState = {
  ready: false,
  loadingConfirmOTP: false,
};

export const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_READY:
      return { ...state, ready: true };

    case LOGIN:
      return { ...state, init: null, loadingConfirmOTP: true };

    case LOGIN_ERROR:
      return {
        ...state,
        init: null,
        error: action.error,
        loadingConfirmOTP: false,
      };

    case LOGIN_SUCCESS:
      return { ...state, init: action.payload, loadingConfirmOTP: false };

    default:
      return state;
  }
};

/**
 * Actions
 */

export const actionLogin = (data) => ({
  type: LOGIN,
  data,
});

export const checkStatus = (secs) => ({
  type: CHECK_STATUS,
  data: {
    secs,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      login: actionLogin,
      checkStatus,
    },
    dispatch
  );
};

/**
 * Apis
 */
const getMenuApi = () => {
  return apiCaller.get(`/portal-mgt/portal/info`);
};
const getUserApi = () => {
  return apiCaller.get(`/id/user/status`);
};

const getInfoAgent = () => {
  return apiCaller.get(
    `/call-center/agent-status?filter={"where": {"id": {"neq": "stop"}}}`
  );
};

const getAgentStatus = () => {
  return apiCaller.get("/call-center/agent/status");
};

/**
 * sagas
 */

const authorize = function* (data) {
  try {
    cookies.set(COOKIE_TOKEN, data.id);
    cookies.setCookieOtherDomain(
      COOKIE_TOKEN,
      data.id,
      "https://chat-omni.cloud-rnd.com"
    );
    apiCaller.setToken(data.id);
    const agentStatus = yield call(getAgentStatus);
    const user = yield call(getUserApi);
    yield put({
      type: LOGIN_SUCCESS,
      payload: {
        ...data,
        agentStatus: agentStatus.data,
        profile: user.data,
        ...user.data.token,
      },
    });
    cookies.set("agentId", agentStatus.data.id);
    window.globalThis.isLogoutProcess = false;
    const history = globalHistory();
    history.push(`${process.env.REACT_APP_PATH}`);
  } catch (error) {
    console.log("error", error);
    yield put({ type: LOGIN_ERROR, error });
    enqueueSnackbar({
      message: "Đăng nhập thất bại",
      variant: "error",
    });
  } finally {
    if (yield cancelled()) {
      yield put({ type: LOGIN_CANCEL });
    }
  }
};

export const loginFlow = function* () {
  while (true) {
    const { data } = yield take(LOGIN);
    // fork return a Task object
    const task = yield fork(authorize, data);
    const action = yield take([LOGOUT, LOGIN_ERROR, LOGIN_SUCCESS]);
    if (action.type === LOGOUT) yield cancel(task);
  }
};

/**
 * check init flow
 */

export const initFlow = function* () {
  const token = cookies.get(COOKIE_TOKEN);
  if (token) {
    try {
      apiCaller.setToken(token);
      const rs = yield call(getMenuApi);
      const agent = yield call(getInfoAgent);
      const user = yield call(getUserApi);
      const agentStatus = yield call(getAgentStatus);
      yield put({
        type: LOGIN_SUCCESS,
        payload: {
          ...rs.data,
          listStatusAgent: agent.data,
          profile: user.data,
          ...user.data.token,
          agentStatus: agentStatus.data,
        },
      });
      cookies.set("agentId", agentStatus.data.id);
      cookies.set("userId", agentStatus.data.userId);
      cookies.setCookieOtherDomain(
        "agentId",
        agentStatus.data.id,
        "https://chat-omni.cloud-rnd.com"
      );
      cookies.setCookieOtherDomain(
        "userId",
        agentStatus.data.userId,
        "https://chat-omni.cloud-rnd.com"
      );
    } catch (error) {
      // yield put({ type: LOGIN_ERROR, error })
    }
    // const apiKey = yield call(getApiKey)
    // if(!!apiKey){
    //     apiConnect.setToken('x-api-key', apiKey.data.result.apiKey)
    // }
  }
  yield put({ type: INIT_READY });
};

export const checkStatusFlow = function* () {
  const action = yield take(CHECK_STATUS);
  yield call(
    setInterval,
    () => {
      getAgentStatus();
    },
    action.data.secs
  );
};

export const isCanLogout = async () => {
  const res = await apiCaller.post("/call-center/agent/status/stop");
  if (res.status === 200 && res.data) {
    if (res.data.error) {
      throw res.data;
    }
    return true;
  }
  throw res;
};
